import model from '../models-v2/partner-staff-board-member';
import routeName from './route-name';


export default [
  {
    path: '/partner-staffs/board-members',
    name: routeName.partnerStaffBoardMember.index,
    components: {
      default: () => import('../pages/data-grid.vue'),
      topRightSection: () => import('../pages/partner-staff-board-member/PartnerStaffBoardMemberTopRightSection.vue'),
    },
    meta: {
      breadcrumb: [
        { title: 'Udziałowcy i zarząd', url: '/partner-staffs/board-members' },
        { title: 'Zarząd', url: '/partner-staffs/board-members' },
      ],
    },
    props: {
      default: (props) => ({ ...props, model }),
      topRightSection: (props) => ({ ...props, actions: model.topRightActions }),
    },
  },
  {
    path: '/partner-staffs/board-members/create',
    name: routeName.partnerStaffBoardMember.store,
    component: () => import('../pages/partner-staff-board-member/PartnerStaffBoardMemberCreateView.vue'),
  },
  {
    path: '/partner-staffs/board-members/edit/:id(\\d+)',
    name: routeName.partnerStaffBoardMember.edit,
    component: () => import('../pages/partner-staff-board-member/PartnerStaffBoardMemberEditView.vue'),
  },
];
